import { DynamicStandaloneIcon, DynamicStandaloneIconProps } from '@/components/Icon';
import { useClassName } from '@/styles/ShowsSlider';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export interface ShowsSliderCaptionProps extends ComponentProps<'div'> {
  $icon?: DynamicStandaloneIconProps['options'];
}

export const ShowsSliderCaptionComponent: Component<ShowsSliderCaptionProps> = ({ children, $icon, ...props }) => {
  const className = useClassName('caption', props);
  const iconClassName = useClassName('icon', props);

  return (
    <div {...mergeProps({ className }, props)}>
      {children}
      <DynamicStandaloneIcon name="teaserArrow" options={{ className: iconClassName }} {...$icon} />
    </div>
  );
};
